export default "__VITE_ASSET__D55kGaqq__"